(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
document.addEventListener('change', (event) => {
  if (!event.target.matches('[data-collection-sort] select')) return;
  const url = new URL(window.location.href);
  url.searchParams.delete(event.target.name);
  if (event.target.value) {
    const values = event.target.name === 'filter.v.t.shopify.color-pattern' ? event.target.value.split(',') : [event.target.value];
    values.forEach(value => url.searchParams.append(event.target.name, value));
  }
  url.searchParams.delete('page');
  window.location.assign(url.href);
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-search"]) return;
  try {
    
document.addEventListener('change', (event) => {
  if (!event.target.matches('[data-search-sort] select')) return;
  event.target.form.submit();
});

  } catch(e) { console.error(e); }
})();
})();
